import { Capacitor } from '@capacitor/core';
import { usePrivy } from '@privy-io/react-auth';
import { useNavigate } from 'react-router-dom';

const useCustomLogin = () => {
  const { login } = usePrivy();

  const navigate = useNavigate();

  return {
    login: Capacitor.isNativePlatform() ? () => navigate('/') : login,
  };
};

export default useCustomLogin;
